import { useInjection } from 'inversify-react';
import { useState } from 'react';

import { Button, Panel } from '@desygner/ui-common-components';

import { IViewerStoreInjector, TYPES } from '../../../../inversify.config';
import {
  StyledBottomNav,
  StyledButtonSize,
  StyledFullScreenModeWrapper,
  StyledLeftFlexBox,
  StyledRightFlexBox,
  StyledZoomControllerWrapper,
} from './BottomNav.styles';
import { FullScreenMode } from './FullScreenMode/FullScreenMode';
import { PageNavigationController } from './PageNavigationController/PageNavigationController';
import { ThumbnailsPanel } from './ThumbnailsPanel/ThumbnailsPanel';
import { VideoControllers } from './VideoControllers/VideoControllers';
import { ZoomController } from './Zoom/ZoomController';

export type BottomNavProps = {
  visible: boolean;
};

export const BottomNav = ({ visible }: BottomNavProps) => {
  const [open, setOpen] = useState(false);
  const useStoreViewer = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const isSinglePageMode = useStoreViewer((state) => state.pageMode === 'single');
  const computeThumbnailPanelVisibility =
    isSinglePageMode && !open ? open : !isSinglePageMode ? open : visible;

  return (
    <>
      <StyledBottomNav visible={visible}>
        <StyledLeftFlexBox>
          <StyledButtonSize>
            <Panel>
              <Panel.Content>
                <Button
                  active={open}
                  action="thumbnails"
                  dataset={{
                    thumbnails: open ? 'close' : 'open',
                  }}
                  icon={{
                    name: 'template---grid---alt2',
                  }}
                  size="Small"
                  variant="ghost"
                  onClick={() => setOpen(!open)}
                />
              </Panel.Content>
            </Panel>
          </StyledButtonSize>
          <Panel>
            <Panel.Content>
              <PageNavigationController />
            </Panel.Content>
          </Panel>
        </StyledLeftFlexBox>

        <VideoControllers />
        <StyledRightFlexBox>
          <StyledZoomControllerWrapper>
            <ZoomController />
          </StyledZoomControllerWrapper>
          <StyledFullScreenModeWrapper>
            <FullScreenMode />
          </StyledFullScreenModeWrapper>
        </StyledRightFlexBox>
      </StyledBottomNav>

      <ThumbnailsPanel open={computeThumbnailPanelVisibility} />
    </>
  );
};
